import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/report-basic-salary-histories', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const exportExcel = attributes => {
  return httpClient
    .post('/api/report-basic-salary-histories/export', attributes, { responseType: 'arraybuffer' })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const exportPdf = attributes => {
  return httpClient
    .post('/api/report-basic-salary-histories/pdf', attributes)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { get, exportExcel, exportPdf }
